import type { DiscoveredRouteModule } from '@/router/generator/types';

// Use ProjectsView as a placeholder component; redirect will take effect immediately
const ProjectsView = () => import('@/views/ProjectsView.vue');

export const NAME_ROOT_INDEX = 'RootIndex';
export const PATH_ROOT = '/';

export const route: DiscoveredRouteModule = {
  id: 'root.index',
  scope: 'root',
  name: NAME_ROOT_INDEX,
  path: PATH_ROOT,
  component: ProjectsView,
  // Redirect differs by project type; generator will translate name to path
  // For white_label: go to /projects; for private_label: go to app variant default (e.g., /home or /directory)
  redirect: (to: any) => {
    // Use a name-based redirect the assembler will not alter; root is outside project wrapper
    return { name: 'ProjectsIndex' };
  },
  meta: { requiresAuth: false, skipProjectCheck: true }
};


